import React from 'react';
import Logo from 'images/logo.png';
import Bg from 'images/bg.png';
import BgMobile from 'images/bg_mobile.png';
import './style.css';

export const AuthLayout = ({authForm}) => {

    return (
        <div className="container-fluid auth-z">
            <div className="row">

                <div className="col-12 col-lg-7 left-panel d-flex align-items-center">
                    <img src={Bg} alt="background shape" className="bg-shape desktop-bg"/>
                    <img src={BgMobile} alt="background shape" className="bg-shape mobile-bg"/>
                    <div className="content w-100">
                        <h1 className="display-5 fw-bold mobile-h">Deep Research,<br/>Delivered Instantly</h1>
                        <p className="fs-4 mt-4 mobile-h">Ask anything. Get a detailed,<br/>sourced report in minutes.</p>
                        <p className="text-info mt-4 mobile-p">Ozmosys AI Assistant goes beyond search,<br/>delivering reasoned insights fast.</p>
                        <p className="text-info mt-4 mobile-p">Save time. Inform your strategy. Stay ahead.</p>
                    </div>
                </div>


                <div className="col-12 col-lg-5 d-flex flex-column justify-content-between min-vh-100 py-5 py-lg-0 auth-form-container">

                    <div className="d-flex justify-content-lg-end justify-content-center pe-lg-5 mt-lg-4 mb-4 mb-lg-0 auth-logo-container">
                        <img src={Logo} alt="Ozmosys Logo" className="logo"/>
                    </div>

                    {authForm}

                    <div className="text-center text-muted small pb-6 auth-form-footer">
                        &copy; 2025 Ozmosys, Inc. All rights reserved
                    </div>
                </div>

            </div>
        </div>
    );
};
